import { render } from "./RadioBox.vue?vue&type=template&id=2d8cd558&scoped=true"
import script from "./RadioBox.vue?vue&type=script&lang=js"
export * from "./RadioBox.vue?vue&type=script&lang=js"

import "./RadioBox.vue?vue&type=style&index=0&id=2d8cd558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8cd558"]])

export default __exports__